export const potok = [
  {
    id: "62ba0c283ca1f692853ebe97",
    like: false,
    name: "Dance Wave Retro!",
    url: "https://retro.dancewave.online/retrodance.mp3",
    img: "https://www.radio.net/images/broadcasts/e3/ef/39943/2/c300.png",
    genre: "Retro pop",
  },
  {
    id: "62ba0c283ca1f692853ebe98",
    like: false,
    name: "Dance Wave!",
    url: "https://dancewave.online/dance.mp3",
    img: "https://www.radiobells.com/stations/dancewave.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebe99",
    like: false,
    name: "Deep Melon radio",
    url: "https://stream.melonradio.com/deep",
    img: "https://www.radiobells.com/stations/melondeep.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebe9d",
    like: false,
    name: "Dorognoe frontovaya",
    url: "https://dorognoe.hostingradio.ru:8000/dorognoe1945.mp3",
    img: "https://radiocanal.ru/assets/cache_image/assets/upload/dorozhnoe_350x150_429.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebea1",
    like: false,
    name: "Fresh FM Sosnovy Bor 105.0 Mhz",
    url: "https://a2.radioheart.ru:8007/live",
    img: "https://top-radio.ru/assets/image/radio/180/fresh105.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebea9",
    like: false,
    name: "House Melon radio",
    url: "https://stream.melonradio.com/house",
    img: "https://www.radiobells.com/stations/melonlounge_100.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebeab",
    like: false,
    name: "Jazz FM.ru - Instrumental",
    url: "https://jfm1.hostingradio.ru:14536/ijstream.mp3",
    img: "https://m.media-amazon.com/images/I/51cgz-8bSOL._UXNaN_FMjpg_QL85_.jpg",
    genre: "Jazz",
  },
  {
    id: "62ba0c283ca1f692853ebeac",
    like: false,
    name: "Jazz FM.ru - Jazz Legends",
    url: "https://jfm1.hostingradio.ru:14536/jlstream.mp3",
    img: "https://i.pinimg.com/236x/df/cc/fd/dfccfdab587f69249c7e318a26c899dd--jazz-radio-online-jazz-concert.jpg",
    genre: "Jazz",
  },
  {
    id: "62ba0c283ca1f692853ebeaf",
    like: false,
    name: "Lounge Melon radio",
    url: "https://stream.melonradio.com/lounge",
    img: "https://pcradio.ru/images/stations/61b09c4125a5b.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebedd",
    like: false,
    name: "Radio DRIVE www.radiogora.ru",
    url: "https://listen.radiogora.ru:8000/drive128",
    img: "https://www.radio.net/images/broadcasts/53/01/39222/1/c300.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebede",
    like: false,
    name: "Radio ELECTRO www.radiogora.ru",
    url: "https://listen.radiogora.ru:8000/electro32",
    img: "https://www.getmeradio.com/stations/electroradio-3453/logos/512x512.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebee0",
    like: false,
    name: "Radio ET CETERA www.radiogora.ru",
    url: "https://listen.radiogora.ru:8000/etc320",
    img: "https://www.radiobells.com/stations/radiogoraetcetera.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebee4",
    like: false,
    name: "Radio HIPHOP www.radiogora.ru",
    url: "https://listen.radiogora.ru:8000/hiphop128",
    img: "https://top-radio.ru/assets/image/radio/180/hip-hop-radio.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebee5",
    like: false,
    name: "Radio HITMIX www.radiogora.ru",
    url: "https://listen.radiogora.ru:8000/hitmix128",
    img: "https://www.radio.net/images/broadcasts/b3/17/110243/17/c300.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebee7",
    like: false,
    name: "Radio Lyantor 100.3 FM",
    url: "https://a2.radioheart.ru:8015/admin",
    img: "https://onradios.ru/wp-content/uploads/2016/05/radio-lyantor-fm.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebeea",
    like: false,
    name: "Radio Mixa Dance FM",
    url: "https://stream.mixadance.fm/mixadance",
    img: "https://top-radio.ru/assets/image/radio/180/mixadance-fm.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebeed",
    like: false,
    name: "Radio OLDIES www.radiogora.ru",
    url: "https://listen.radiogora.ru:8000/oldies128",
    img: "https://cdn-radiotime-logos.tunein.com/s204018g.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebeee",
    like: false,
    name: "Radio Podsolnuh 102.9 FM",
    url: "https://live.podsolnuh.media:8000/radio",
    img: "https://www.radiobells.com/stations/podsolnukh.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebef0",
    like: false,
    name: "Radio REDNOISE www.radiogora.ru",
    url: "https://listen.radiogora.ru:8000/rednoise128",
    img: "https://images.keepone.net/421458-2017-03-13.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebef9",
    like: false,
    name: "Radio-Remix",
    url: "https://radio-remix.ru:8000/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebefd",
    like: false,
    name: "Radiokrylya",
    url: "https://myradio24.org/rkradio_256.mp3",
    img: "https://static.wixstatic.com/media/0aca94_e255cb0c7df74818adb93bc3b6795062.jpg/v1/fill/w_560,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/0aca94_e255cb0c7df74818adb93bc3b6795062.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebf0b",
    like: false,
    name: "Soulful Melon radio",
    url: "https://stream.melonradio.com/soulful",
    img: "https://topradio.me/assets/image/radio/180/melon-radio-soulful.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebf15",
    like: false,
    name: "Tipichnoe FM Щелково",
    url: "https://myradio24.org/9696",
    img: "https://top-radio.ru/assets/image/radio/180/tipichnoe-fm.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebf1a",
    like: false,
    name: "Yum FM",
    url: "https://yumfm.hostingradio.ru:8020/yumfm128.mp3",
    img: "https://radiofon.net/uploads/posts/2017-02/1485949185_yum-fm.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebf30",
    like: false,
    name: "Радио Буу!",
    url: "https://buu.hostingradio.ru:8005/radio",
    img: "https://top-radio.ru/assets/image/radio/180/radiobuu.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebf31",
    like: false,
    name: "Радио Книга",
    url: "https://bookradio.hostingradio.ru:8069/fm",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "AudioBook",
  },
  {
    id: "62ba0c283ca1f692853ebf33",
    like: false,
    name: "Радио Меридиан",
    url: "https://stream.gtf.club:8030/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebf38",
    like: false,
    name: "Радио Родных Дорог",
    url: "https://stream1.radiord.ru:8000/live96.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfc5",
    like: false,
    name: "Europa Plus",
    url: "https://ep256.hostingradio.ru:8052/europaplus256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfc7",
    like: false,
    name: "Fresh FM",
    url: "https://a2.radioheart.ru:8007/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfd2",
    like: false,
    name: "Kamchatka Live-Chill",
    url: "https://radio.kamchatkalive.ru:8100/chillout",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfd3",
    like: false,
    name: "Kamchatka Live-Dance",
    url: "https://radio.kamchatkalive.ru:8100/dance",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfd4",
    like: false,
    name: "Kamchatka Live-Rock",
    url: "https://radio.kamchatkalive.ru:8100/rock",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "62ba0c283ca1f692853ebfe9",
    like: false,
    name: "Radio Gora-ATD",
    url: "https://listen.radiogora.ru:8000/atd128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfea",
    like: false,
    name: "Radio Gora-Drive",
    url: "https://listen.radiogora.ru:8000/drive128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfeb",
    like: false,
    name: "Radio Gora-Electro",
    url: "https://listen.radiogora.ru:8000/electro128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfec",
    like: false,
    name: "Radio Gora-Et Cetera",
    url: "https://listen.radiogora.ru:8000/etc128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfed",
    like: false,
    name: "Radio Gora-Freaky Funky",
    url: "https://listen.radiogora.ru:8000/freakyfunky320",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebfee",
    like: false,
    name: "Radio Gora-Groove Cafe",
    url: "https://listen.radiogora.ru:8000/groovecafe320",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebff2",
    like: false,
    name: "Rock FM-00",
    url: "https://jfm1.hostingradio.ru:14536/rock00.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "62ba0c283ca1f692853ebff3",
    like: false,
    name: "Rock FM-70",
    url: "https://jfm1.hostingradio.ru:14536/rock70.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "62ba0c283ca1f692853ebff4",
    like: false,
    name: "Rock FM-80",
    url: "https://jfm1.hostingradio.ru:14536/rock80.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "62ba0c283ca1f692853ebff5",
    like: false,
    name: "Rock FM-90",
    url: "https://jfm1.hostingradio.ru:14536/rock90.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "62ba0c283ca1f692853ebff6",
    like: false,
    name: "Rock FM-Heavy",
    url: "https://jfm1.hostingradio.ru:14536/metal.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ebff7",
    like: false,
    name: "Rock FM-Prog",
    url: "https://jfm1.hostingradio.ru:14536/prog.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "62ba0c283ca1f692853ebff8",
    like: false,
    name: "Rock FM",
    url: "https://nashe1.hostingradio.ru:18000/rock-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "62ba0c283ca1f692853ec014",
    like: false,
    name: "Zaycev.fm-K-Pop",
    url: "https://zaycevfm.cdnvideo.ru/ZaycevFM_kpop_128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec016",
    like: false,
    name: "Бизнес FM",
    url: "https://bfm.hostingradio.ru:8004/fm",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec01e",
    like: false,
    name: "ВЭБ Радио",
    url: "https://m5m128.hostingradio.ru:8074/m5m128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec01f",
    like: false,
    name: "Говорит Майкоп",
    url: "https://voicemaikop.hostingradio.ru:8003/voicemaikop128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec025",
    like: false,
    name: "Дорожное Радио СПб",
    url: "https://dorognoe.hostingradio.ru:8000/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec02b",
    like: false,
    name: "Кавказ Хит",
    url: "https://kavkazhit.hostingradio.ru:8017/kavkazhit96.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec02d",
    like: false,
    name: "Классное Радио",
    url: "https://schoolradio.hostingradio.ru:8026/schoolradio128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec038",
    like: false,
    name: "Наше 2.0",
    url: "https://nashe1.hostingradio.ru:18000/nashe20-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec039",
    like: false,
    name: "Наше Радио Классик-рок",
    url: "https://nashe1.hostingradio.ru:18000/nasheclassic.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec03a",
    like: false,
    name: "Наше Радио Панки-хой!",
    url: "https://nashe1.hostingradio.ru:18000/nashepunks.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec03b",
    like: false,
    name: "Наше Радио Щас-спою",
    url: "https://nashe1.hostingradio.ru:18000/nashesongs.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec03c",
    like: false,
    name: "Наше Радио",
    url: "https://nashe1.hostingradio.ru:18000/nashe-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec03d",
    like: false,
    name: "Нефтерадио",
    url: "https://m10m128.hostingradio.ru:8074/m10m128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec04b",
    like: false,
    name: "Радио Best",
    url: "https://nashe1.hostingradio.ru:18000/best-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec04e",
    like: false,
    name: "Радио Jazz-Classic",
    url: "https://jfm1.hostingradio.ru:14536/ijstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "62ba0c283ca1f692853ec04f",
    like: false,
    name: "Радио Jazz-Jazz Legends",
    url: "https://jfm1.hostingradio.ru:14536/jlstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "62ba0c283ca1f692853ec050",
    like: false,
    name: "Радио Jazz-Smooth Jazz",
    url: "https://jfm1.hostingradio.ru:14536/sjstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "62ba0c283ca1f692853ec051",
    like: false,
    name: "Радио Ultra",
    url: "https://nashe1.hostingradio.ru:18000/ultra-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec05b",
    like: false,
    name: "Радио Буу",
    url: "https://buu.hostingradio.ru:8005/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec05c",
    like: false,
    name: "Радио Вера-Вера и время",
    url: "https://radiovera.hostingradio.ru:8007/radioveragorod128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Religion",
  },
  {
    id: "62ba0c283ca1f692853ec05d",
    like: false,
    name: "Радио Вера-Классик",
    url: "https://radiovera.hostingradio.ru:8007/radioverausadba128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Religion",
  },
  {
    id: "62ba0c283ca1f692853ec05f",
    like: false,
    name: "Радио Вера-О людях и смыслах",
    url: "https://radiovera.hostingradio.ru:8007/radioverasvetliyvecher128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Religion",
  },
  {
    id: "62ba0c283ca1f692853ec060",
    like: false,
    name: "Радио Вера",
    url: "https://radiovera.hostingradio.ru:8007/radiovera_128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Religion",
  },
  {
    id: "62ba0c283ca1f692853ec062",
    like: false,
    name: "Радио Гамаюн",
    url: "https://gamaun.online:8010/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcd640e880dda2",
    like: false,
    name: "Радио Гамаюн/Москва/128-MP3",
    url: "http://gamaun.online:8010/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec066",
    like: false,
    name: "Радио Искатель",
    url: "https://iskatel.hostingradio.ru:8015/iskatel-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ec07d",
    like: false,
    name: "Радио Нестандарт",
    url: "https://listen.radionestandart.ru:8200/128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ecf1c",
    like: false,
    name: "Центр FM",
    url: "https://stream2.datacenter.by/stream",
    img: "https://top-radio.ru/assets/image/radio/180/centerfm.jpg",
    genre: "Pop",
  },
  {
    id: "62ba0c283ca1f692853ecf30",
    like: false,
    name: "Шоколад",
    url: "https://choco.hostingradio.ru:10010/fm",
    img: "https://chocoradio.ru/upload/dev2fun_opengraph/625/62585f72a847b550a6d2eb42c5961b3b.png",
    genre: "Pop",
  },
  {
    id: "63ba0c283ca1f692853ec07d",
    like: false,
    name: "Вести FM",
    url: "https://icecast-vgtrk.cdnvideo.ru/vestifm_aac_64kbps",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "64vb6c283ca1f692853ec07d",
    like: false,
    name: "Русское радио",
    url: "https://rusradio.hostingradio.ru/rusradio96.aacp",
    img: "https://radiopotok.ru/f/station/512/85.png",
    genre: "Pop",
  },
  {
    id: "id26ac8c763d9f",
    like: false,
    name: "Радио Cassiopeia Station",
    url: "https://stream.cassiopeia-station.ru:1095/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "News",
  },
  {
    id: "id75fca44ceeba1",
    like: false,
    name: "Вести FM",
    url: "https://icecast-vgtrk.cdnvideo.ru/vestifm_aac_64kbps",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "News",
  },
  {
    id: "id627c2462584bd",
    like: false,
    name: "Комсомольская правда",
    url: "https://kpradio.hostingradio.ru:8000/64?radiostatistica=radiokp.ru",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide0f9440ba9775",
    like: false,
    name: "Народное Славянское радио",
    url: "https://slavradio.org:8443/nsr/1/",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf64defca394ab",
    like: false,
    name: "Бизнес ФМ",
    url: "https://bfm.hostingradio.ru:9075/fm",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide9111338add61",
    like: false,
    name: "Радио ФМ-на Дону (Волгодонск)",
    url: "http://listen.vdfm.ru:8000/fmnadonu",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2296fffeda32",
    like: false,
    name: "Радио Маруся FM",
    url: "http://pub0201.101.ru:8000/stream/pull/aac/64/301",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id46ba249ea7025",
    like: false,
    name: "Детский Хит",
    url: "https://deti.amgradio.ru/Deti",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idfea9a104dde45",
    like: false,
    name: "Русское Радио - Детский",
    url: "https://rr-detskijkanal.hostingradio.ru/detskijkanal96.aacp",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id7806b5802ad85",
    like: false,
    name: "Positively Sleep Baby",
    url: "https://streaming.positivity.radio/pr/sleepbaby/icecast.audio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id93482c2bcef7c",
    like: false,
    name: "Positively Sleep Kids",
    url: "https://streaming.positivity.radio/pr/sleepkids/icecast.audio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id07822dfac91fe",
    like: false,
    name: "Comedy Радио",
    url: "http://online-1.gkvr.ru:8000/comedy_kem_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida2a349fbaf605",
    like: false,
    name: "Love Радио",
    url: "http://online-1.gkvr.ru:8000/love_kem_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id1d60cd1832656",
    like: false,
    name: "Авторадио",
    url: "http://online-1.gkvr.ru:8000/avtoradio_vld_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id5f9b36009b8e6",
    like: false,
    name: "Дорожное Радио (Новосибирск)",
    url: "http://online-1.gkvr.ru:8000/dorozhnoe_nsb_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida9494de5b5709",
    like: false,
    name: "Европа Плюс",
    url: "http://online-1.gkvr.ru:8000/europa_krd_128.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide6fc7486fd108",
    like: false,
    name: "Наше радио",
    url: "http://online-1.gkvr.ru:8000/nashe_kaz_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idbae9968ed90c",
    like: false,
    name: "Новое Радио",
    url: "http://online-1.gkvr.ru:8000/novoe_kra_64onair.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idb30b22ab18b8",
    like: false,
    name: "Радио 7 на семи холмах",
    url: "http://online-1.gkvr.ru:8000/radio7_kra_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id89808a075ee7e",
    like: false,
    name: "Радио DFM",
    url: "http://online-1.gkvr.ru:8000/dfm11_vld_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida16c47b078dd9",
    like: false,
    name: "Радио DFM (Новокузнецк)",
    url: "http://online-1.gkvr.ru:8000/dfm_nkz_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id3b373baff26f3",
    like: false,
    name: "Радио Бизнес FM",
    url: "http://online-1.gkvr.ru:8000/bfm_nsb_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id10906ce94b1bd",
    like: false,
    name: "Радио Дача",
    url: "http://online-1.gkvr.ru:8000/dacha_eka_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd8d9252e970d5",
    like: false,
    name: "Радио Дача (Ижевск)",
    url: "http://online-1.gkvr.ru:8000/dacha_izh_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id085972ef7b4f8",
    like: false,
    name: "Радио Дача (Краснодар) 128",
    url: "http://online-1.gkvr.ru:8000/dacha_krd_128.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide07c2bdd97b9d",
    like: false,
    name: "Радио Монте-Карло",
    url: "http://online-1.gkvr.ru:8000/mc_eka_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id60c01ce1f669",
    like: false,
    name: "Радио Монте-Карло (Калуга)",
    url: "http://online-1.gkvr.ru:8000/mc_klg_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id54f0b3e0a8f9a",
    like: false,
    name: "Радио Рекорд (Екатеринбург)",
    url: "http://online-1.gkvr.ru:8000/record_eka_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id671d3be4f3cb9",
    like: false,
    name: "Ретро FM (Саратов)",
    url: "http://online-1.gkvr.ru:8000/retro_srt_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida63d0b7237497",
    like: false,
    name: "Русское Радио (Калуга)",
    url: "http://online-1.gkvr.ru:8000/rusradio_klg_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd5c88e9fa2674",
    like: false,
    name: "Хит FM (Екатеринбург)",
    url: "http://online-1.gkvr.ru:8000/hitfm_eka_64.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6863cffddc889",
    like: false,
    name: "BFM Radio",
    url: "http://audio.bfmtv.com/bfmradio_128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id170eca50a2899",
    like: false,
    name: "DE:CoreTime FM",
    url: "http://aachd.stream.tb-group.fm:80/ct-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id83d116f0dc41c",
    like: false,
    name: "DE:HardBase FM",
    url: "http://aachd.stream.tb-group.fm:80/hb-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id70a72bc8f17a4",
    like: false,
    name: "DE:HouseTime FM",
    url: "http://aachd.stream.tb-group.fm:80/ht-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id05799bec1fbee",
    like: false,
    name: "DE:Replay FM",
    url: "http://aachd.stream.tb-group.fm:80/rp-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idda99a95e8e472",
    like: false,
    name: "DE:TeaTime FM",
    url: "http://aachd.stream.tb-group.fm:80/tt-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id008049bec0299",
    like: false,
    name: "DE:TechnoBase FM",
    url: "http://aachd.stream.tb-group.fm:80/tb-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8de1c8aff08a8",
    like: false,
    name: "DE:TranceBase FM",
    url: "http://aachd.stream.tb-group.fm:80/trb-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id78206246535f7",
    like: false,
    name: "ERR Klara Jazz",
    url: "http://icecast.err.ee/klarajazzkorge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "id617d5509432a7",
    like: false,
    name: "ERR Radio 2",
    url: "http://icecast.err.ee/raadio2korge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id9f4347a7e257a",
    like: false,
    name: "ERR Radio 2 Alt Pop",
    url: "http://icecast.err.ee/r2alternatiivkorge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf1765e1e90671",
    like: false,
    name: "ERR Radio 2 Eesti",
    url: "http://icecast.err.ee/r2eestikorge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id196e5aeeb6e8e",
    like: false,
    name: "ERR Radio 2 Pop",
    url: "http://icecast.err.ee/r2popkorge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8f9182cf13e46",
    like: false,
    name: "ERR Radio 2 Rap",
    url: "http://icecast.err.ee/r2pkorge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id97fcfa0206d2f",
    like: false,
    name: "ERR Radio 4",
    url: "http://icecast.err.ee:80/raadio4korge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idb8058740d1e73",
    like: false,
    name: "ERR Radio Tallinn",
    url: "http://icecast.err.ee:80/raadiotallinnkorge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6f21a481b19c2",
    like: false,
    name: "ERR Viker Radio",
    url: "http://icecast.err.ee/vikerraadiokorge.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6d561374e4b67",
    like: false,
    name: "Fun Radio",
    url: "http://stream.funradio.sk:8000/fun192.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id727194e00c446",
    like: false,
    name: "Fun Radio 80-90",
    url: "http://stream.funradio.sk:8000/80-90-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idae33c562289af",
    like: false,
    name: "Fun Radio Chill",
    url: "http://stream.funradio.sk:8000/chill128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idfee1ca4547eb9",
    like: false,
    name: "Fun Radio Cz-Sk",
    url: "http://stream.funradio.sk:8000/cs128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2ec77afc2abb1",
    like: false,
    name: "Fun Radio Dance",
    url: "http://stream.funradio.sk:8000/dance128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id366abb0d09176",
    like: false,
    name: "Happy Radio",
    url: "http://stream.zeno.fm/nkeaps48xg0uv",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idbfb9a38e9b857",
    like: false,
    name: "LWR Radio Dubstep",
    url: "http://lwrdubstep-zaklwr10.radioca.st/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide158c97e84de1",
    like: false,
    name: "LWR Radio House",
    url: "http://lwrhouse-zaklwr10.radioca.st/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd03cdf1dbb354",
    like: false,
    name: "LWR Radio Reload",
    url: "http://lwrreload-zaklwr10.radioca.st/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc19d19e1f22e",
    like: false,
    name: "LWR Radio Rock",
    url: "http://lwrrock-zaklwr10.radioca.st/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id0145a76c4fda9",
    like: false,
    name: "Lav Radio (ARM)",
    url: "https://eu.stream4cast.com/proxy/lavradio/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id05b872667ca52",
    like: false,
    name: "Lav Radio Mix",
    url: "https://eu.stream4cast.com/proxy/lavradiomix/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc380bb8efad9f",
    like: false,
    name: "Love Radio (GRE)",
    url: "http://netradio.live24.gr/loveradio-1000",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "iddce1c31709b4d",
    like: false,
    name: "PulsRadio 80's",
    url: "http://icecast.pulsradio.com/magicradioHD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf7010c076cd6",
    like: false,
    name: "PulsRadio 90's",
    url: "http://icecast.pulsradio.com:80/puls90HD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8b58fd41704f3",
    like: false,
    name: "PulsRadio DANCE",
    url: "http://icecast.pulsradio.com:80/pulsHD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id46bb8e75c4827",
    like: false,
    name: "PulsRadio HIT UK",
    url: "http://icecast.pulsradio.com/hitukHD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0247779f48c49",
    like: false,
    name: "PulsRadio HITS",
    url: "http://icecast.pulsradio.com:80/hitpartyHD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc222b30dbcd13",
    like: false,
    name: "PulsRadio LOUNGE",
    url: "http://icecast.pulsradio.com/relaxHD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "idc43d5c08b1f13",
    like: false,
    name: "PulsRadio MX CLUB",
    url: "http://icecast.pulsradio.com/mxHD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida50a59462b6af",
    like: false,
    name: "PulsRadio TRANCE",
    url: "http://icecast.pulsradio.com:80/pulstranceHD.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id614b6d5a5e611",
    like: false,
    name: "RM FM - Club",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/club",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0080294e44ddc",
    like: false,
    name: "RM FM - Harder",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/harder",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id88d3d3d2314e4",
    like: false,
    name: "RM FM - House",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/house",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ided42e8ca22acb",
    like: false,
    name: "RM FM - Jam",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/jam",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "iddb23df7d65ad2",
    like: false,
    name: "RM FM - Lounge",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/lounge",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "iddf813bd3c02ec",
    like: false,
    name: "RM FM - Main",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/main",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id216d724b9f29",
    like: false,
    name: "RM FM - Rock",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/rock",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id9a0762c9d6a85",
    like: false,
    name: "RM FM - Schlager",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/schlager",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id74ea659f00511",
    like: false,
    name: "RM FM - Sex",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/sex",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id53ab0f7a8cfe8",
    like: false,
    name: "RM FM - Shredded",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/shredded_mp3-192",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida7c75b010c44a",
    like: false,
    name: "RM FM - Top 40",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/top40",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida41cec39e6b94",
    like: false,
    name: "RM FM - Trance",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/trance",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id1e08823bc20f",
    like: false,
    name: "RM FM - Trap",
    url: "http://rautemusik-de-hz-fal-stream12.radiohost.de/trap",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "iddcf2305f3cb14",
    like: false,
    name: "Radio 10 60&70 Hits",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR18.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id4e75e60ad5567",
    like: false,
    name: "Radio 10 80 Hits",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR20.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0976d137e29c6",
    like: false,
    name: "Radio 10 90 Hits",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR22.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id5285442b0ca12",
    like: false,
    name: "Radio 10 Disco Classics",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR23.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0032f2b782948",
    like: false,
    name: "Radio 10 Love Songs",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR04.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id1a3aea911aeaa",
    like: false,
    name: "Radio 10 Non-Stop",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR15.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2abe7e616cd68",
    like: false,
    name: "Radio 10 Top 4000",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR24.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id90b1f3406afff",
    like: false,
    name: "Radio 100 FM (ISR)",
    url: "https://cdn.cybercdn.live/Radios_100FM/Audio/icecast.audio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id5d6e8a34ec88",
    like: false,
    name: "Radio 103 FM (ISR)",
    url: "https://cdn.cybercdn.live/103FM/Live/icecast.audio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id246a3c81c786a",
    like: false,
    name: "Radio 538 (NL)",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/RADIO538.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id18288792d7fbd",
    like: false,
    name: "Radio 538 Classic",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR08.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0beec66f58c6b",
    like: false,
    name: "Radio 538 Dance Dept",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR01.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idaa3b4973fa02d",
    like: false,
    name: "Radio 538 Die Verruckte",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR21.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id5aa9e3f6f8785",
    like: false,
    name: "Radio 538 Hitzone",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR11.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id5878a551d4ef1",
    like: false,
    name: "Radio 538 Ibiza",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR19.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id59b9eeb6d152d",
    like: false,
    name: "Radio 538 Nonstop",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR09.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id29a86c50d24e8",
    like: false,
    name: "Radio 538 Party",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR16.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id46e6006def751",
    like: false,
    name: "Radio 538 Top 50",
    url: "http://playerservices.streamtheworld.com/api/livestream-redirect/TLPSTR13.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0f3c2a339c5a6",
    like: false,
    name: "Radio BSJ FM (UK)",
    url: "https://bsj.lucasmultimedia.com:8002/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id038b89e8861bc",
    like: false,
    name: "Radio Beat FM (Jordan)",
    url: "https://securestreams2.autopo.st:1242/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id01665f4c20fb4",
    like: false,
    name: "Radio Cernauti (ROM)",
    url: "https://c4.radioboss.fm:18260/autodj",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id88da84d4cf5b5",
    like: false,
    name: "Radio DLRP",
    url: "https://radio.ready2play.fr:1340/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id7a9bfdc366d27",
    like: false,
    name: "Radio Energy (ARM)",
    url: "https://eu.stream4cast.com/proxy/energyfm/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idaf83d9f9fd66a",
    like: false,
    name: "Radio FG Chic",
    url: "https://stream.rcs.revma.com/cgvrymb6p98uv",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcce48bf86c192",
    like: false,
    name: "Radio Jurnal FM (Moldova)",
    url: "https://audio.jurnalfm.md/hq",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id33bcaf9c5b7d5",
    like: false,
    name: "Radio Kronehit (Австрия)",
    url: "https://secureonair.krone.at/kronehit-ultra-hd.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idfc95c026bce3",
    like: false,
    name: "Radio Kronehit Charts",
    url: "https://secureonair.krone.at/kronehit99.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id7ab57b6b38e6f",
    like: false,
    name: "Radio Kronehit Clubland",
    url: "https://secureonair.krone.at/kronehit98.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id06ba050135fa8",
    like: false,
    name: "Radio Kronehit Dance",
    url: "https://secureonair.krone.at/kronehit23.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8667d5f4d12b3",
    like: false,
    name: "Radio Kronehit Eurodance",
    url: "https://secureonair.krone.at/kronehit21.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idb93c2c73c3799",
    like: false,
    name: "Radio Kronehit Fresh",
    url: "https://secureonair.krone.at/kronehit22.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc729cbf0e45be",
    like: false,
    name: "Radio Kronehit Greatest Hits",
    url: "https://secureonair.krone.at/kronehit13.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id03a49efb628c8",
    like: false,
    name: "Radio Kronehit Latino",
    url: "https://secureonair.krone.at/kronehit05.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide8df1c58a4562",
    like: false,
    name: "Radio Kronehit Love",
    url: "https://secureonair.krone.at/kronehit14.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id96bcf0fb8e0fb",
    like: false,
    name: "Radio Kronehit Retro",
    url: "https://secureonair.krone.at/kronehit04.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida75cb277ddeef",
    like: false,
    name: "Radio LFM - 2000",
    url: "https://webradio0009.ice.infomaniak.ch/webradio0009-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id791e43c8bf089",
    like: false,
    name: "Radio LFM - 90s",
    url: "https://webradio0006.ice.infomaniak.ch/webradio0006-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id362ec5d0d8b6a",
    like: false,
    name: "Radio LFM - Latino",
    url: "https://webradio0008.ice.infomaniak.ch/webradio0008-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idee2a854234499",
    like: false,
    name: "Radio LFM - Latitude",
    url: "https://webradio0007.ice.infomaniak.ch/webradio0007-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id780329400e0bd",
    like: false,
    name: "Radio LFM - Love",
    url: "https://webradio0010.ice.infomaniak.ch/webradio0010-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0d1761367d0c7",
    like: false,
    name: "Radio LFM - Scene Francaise",
    url: "https://webradio0005.ice.infomaniak.ch/webradio0005-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd65f625defc92",
    like: false,
    name: "Radio MFM (ARM)",
    url: "https://eu.stream4cast.com/proxy/mfmradio/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd70178b33357c",
    like: false,
    name: "Radio Magic FM (ROM)",
    url: "https://live.kissfm.ro:8443/magicfm.aacp",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc993bcd068897",
    like: false,
    name: "Radio Magic FM (ROM) - Gold Hits",
    url: "https://live.kissfm.ro:8443/magic.gold.hits",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf83615cd49bda",
    like: false,
    name: "Radio Magic FM (ROM) - Party Mix",
    url: "https://live.kissfm.ro:8443/magic.party.mix",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8a956ed48417e",
    like: false,
    name: "Radio OUI FM Blues n Rock",
    url: "https://ouifmbluesnrock.ice.infomaniak.ch/ouifmbluesnrock-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id5f045fe70f022",
    like: false,
    name: "Radio OUI FM Girls Rock",
    url: "https://ouifmgirlsrock.ice.infomaniak.ch/ouifmgirlsrock.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id55d8b8cca3e08",
    like: false,
    name: "Radio OUI FM Rock Francais",
    url: "https://ouifmrockfrancais.ice.infomaniak.ch/ouifmrockfrancais.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id30a2617665061",
    like: false,
    name: "Radio Qebele",
    url: "https://radio.qebele.tv/radio/8010/radio.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id90db9daa5db1b",
    like: false,
    name: "Radio Real Hardstyle (NL)",
    url: "https://stream.realhardstyle.nl/320",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idbe2a0b221d5b3",
    like: false,
    name: "Radio Relax FM (EST)",
    url: "https://stream.relaxfm.ee/relax_HD",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id67103e344e4a5",
    like: false,
    name: "Radio Relax FM Cafe",
    url: "https://stream.relaxfm.ee/cafe_HD",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idfc16b24a59d7b",
    like: false,
    name: "Radio Relax FM Instrumental",
    url: "https://stream.relaxfm.ee/instrumental_HD",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide121d4e8228b8",
    like: false,
    name: "Radio Relax FM Jazz",
    url: "https://stream.relaxfm.ee/jazz_HD",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "id568ca3bd16b51",
    like: false,
    name: "Radio Relaxace Birds",
    url: "https://ice6.abradio.cz/relax-morning-birds128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "ida02a022f0e5d7",
    like: false,
    name: "Radio Relaxace Fire",
    url: "https://ice6.abradio.cz/relax-fire128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "id96ed54c0971c5",
    like: false,
    name: "Radio Relaxace More",
    url: "https://ice6.abradio.cz/relax-sea128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "idd6e7edc04140d",
    like: false,
    name: "Radio Relaxace Thunder Rain",
    url: "https://ice6.abradio.cz/relax-thunder-rain128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id206e06c0c93fe",
    like: false,
    name: "Radio Relaxace Train",
    url: "https://ice6.abradio.cz/relax-train128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "id6f409400bfff5",
    like: false,
    name: "Radio Rock FM (ROM)",
    url: "https://live.kissfm.ro:8443/rockfm.aacp",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id78a924d7aba9a",
    like: false,
    name: "Radio Ruworship",
    url: "https://s.ruworship.ru:8125/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8228f1556d6e5",
    like: false,
    name: "Radio Spinner - 100 Dance Hits",
    url: "https://live.radiospinner.com/100dnc-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id57b0061ecf41b",
    like: false,
    name: "Radio Spinner - Acid Jazz",
    url: "https://live.radiospinner.com/acid-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idc45e2e238d676",
    like: false,
    name: "Radio Spinner - After Party",
    url: "https://live.radiospinner.com/after-party-deep-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id57c1c9885f50e",
    like: false,
    name: "Radio Spinner - Ambient",
    url: "https://live.radiospinner.com/ambient-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idec1490ff167d1",
    like: false,
    name: "Radio Spinner - Ambient Space",
    url: "https://live.radiospinner.com/ambntspc-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id47ff21d71e9de",
    like: false,
    name: "Radio Spinner - Bachata Hit",
    url: "https://live.radiospinner.com/bchtht-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idbf43b371b0711",
    like: false,
    name: "Radio Spinner - Bass House",
    url: "https://live.radiospinner.com/bsshs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id78575b01d76ba",
    like: false,
    name: "Radio Spinner - Blues Club",
    url: "https://live.radiospinner.com/blsclb-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idae6154d2ebbe6",
    like: false,
    name: "Radio Spinner - Blues Rock",
    url: "https://live.radiospinner.com/blsrck-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "ide80cdc7c75713",
    like: false,
    name: "Radio Spinner - Bossa Nova",
    url: "https://live.radiospinner.com/bossa-nova-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcd147f16f3a96",
    like: false,
    name: "Radio Spinner - Buddha Bar Chill",
    url: "https://live.radiospinner.com/bddhbrchll-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id9873a77ad62d5",
    like: false,
    name: "Radio Spinner - Cafe Del Mar",
    url: "https://live.radiospinner.com/cdmr-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6bd3fa7d6811",
    like: false,
    name: "Radio Spinner - Calm Piano",
    url: "https://live.radiospinner.com/clmpn-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8c3cf6ff39a46",
    like: false,
    name: "Radio Spinner - Calm Spa",
    url: "https://live.radiospinner.com/calm-spa-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida42cae8787a3a",
    like: false,
    name: "Radio Spinner - Cartoon Songs",
    url: "https://live.radiospinner.com/crtnsngs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2f424c0ea400a",
    like: false,
    name: "Radio Spinner - Chill EDM",
    url: "https://live.radiospinner.com/chill-edm-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida669325a0f2ad",
    like: false,
    name: "Radio Spinner - Chill House",
    url: "https://live.radiospinner.com/chllhs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id5113f3b07192b",
    like: false,
    name: "Radio Spinner - Chillhop",
    url: "https://live.radiospinner.com/chill-hop-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id9a9b88dbc2653",
    like: false,
    name: "Radio Spinner - East Meditation",
    url: "https://live.radiospinner.com/stmdttn-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc1cf76148ed13",
    like: false,
    name: "Radio Spinner - Electro House",
    url: "https://live.radiospinner.com/electro-house-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id38f7f2c746432",
    like: false,
    name: "Radio Spinner - Electro Pop",
    url: "https://live.radiospinner.com/elecpop-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id4363df74b64e6",
    like: false,
    name: "Radio Spinner - Electro Swing",
    url: "https://live.radiospinner.com/elswing-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcfc13768aa4e",
    like: false,
    name: "Radio Spinner - Enigmatic Bar",
    url: "https://live.radiospinner.com/ngmtcbr-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id08411709c772e",
    like: false,
    name: "Radio Spinner - Enigmatic Chill",
    url: "https://live.radiospinner.com/enigmatic-chill-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id365c17e3b8a88",
    like: false,
    name: "Radio Spinner - Eurodance Classic",
    url: "https://live.radiospinner.com/erdncclssc-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id03bc4a7b42ab2",
    like: false,
    name: "Radio Spinner - Funky House",
    url: "https://live.radiospinner.com/funky-house-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0b6f738250122",
    like: false,
    name: "Radio Spinner - Hard Techo Rave",
    url: "https://live.radiospinner.com/hrdtchnrv-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf043fe65af72a",
    like: false,
    name: "Radio Spinner - Hits 60s",
    url: "https://live.radiospinner.com/60hts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idaaa1eca31a39d",
    like: false,
    name: "Radio Spinner - Hits 70s",
    url: "https://live.radiospinner.com/70hs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id22d340f062fed",
    like: false,
    name: "Radio Spinner - Hits 80s",
    url: "https://live.radiospinner.com/80hs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id20dafb5150266",
    like: false,
    name: "Radio Spinner - Hits 90s",
    url: "https://live.radiospinner.com/90hs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id759222ef37308",
    like: false,
    name: "Radio Spinner - House",
    url: "https://live.radiospinner.com/house-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idafc63df51d9de",
    like: false,
    name: "Radio Spinner - Ibiza Club",
    url: "https://live.radiospinner.com/ibzclb-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2cf5a5ed43afe",
    like: false,
    name: "Radio Spinner - Indie Chill",
    url: "https://live.radiospinner.com/ndchll-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcb30d690061e3",
    like: false,
    name: "Radio Spinner - Indie Pop Hit",
    url: "https://live.radiospinner.com/ndppht-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0f6fe9d155d2f",
    like: false,
    name: "Radio Spinner - Instrumental Hit",
    url: "https://live.radiospinner.com/instht-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id78639d7879802",
    like: false,
    name: "Radio Spinner - Jazz House",
    url: "https://live.radiospinner.com/jazz-house-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idaee659b3d42d",
    like: false,
    name: "Radio Spinner - Latin House",
    url: "https://live.radiospinner.com/lathouse-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8f685ab3dbea2",
    like: false,
    name: "Radio Spinner - Latin Jazz",
    url: "https://live.radiospinner.com/latin-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "id2ab6421670a3e",
    like: false,
    name: "Radio Spinner - Latin Pop Hits",
    url: "https://live.radiospinner.com/ltnpphts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd10df6e9a7795",
    like: false,
    name: "Radio Spinner - Lofi Chill",
    url: "https://live.radiospinner.com/lfch-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id7d881f0c67ac3",
    like: false,
    name: "Radio Spinner - Lofi Hiphop",
    url: "https://live.radiospinner.com/lofi-hip-hop-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd61538f5210e9",
    like: false,
    name: "Radio Spinner - Lounge",
    url: "https://live.radiospinner.com/lounge-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc10a44d52e6da",
    like: false,
    name: "Radio Spinner - Love Jazz",
    url: "https://live.radiospinner.com/love-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "ida6756962d43df",
    like: false,
    name: "Radio Spinner - Mellow Jazz",
    url: "https://live.radiospinner.com/mellow-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idc99e535dc29af",
    like: false,
    name: "Radio Spinner - Minimal Techno",
    url: "https://live.radiospinner.com/minimal-techno-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id78316a2fb4cfa",
    like: false,
    name: "Radio Spinner - Modern Vocal Jazz",
    url: "https://live.radiospinner.com/modern-vocal-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "ide25fc8a7e1523",
    like: false,
    name: "Radio Spinner - Nature",
    url: "https://live.radiospinner.com/nature-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id40cbf9b54a2c6",
    like: false,
    name: "Radio Spinner - Neoclassical Wave",
    url: "https://live.radiospinner.com/nclssclwv-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id9fcab27abda46",
    like: false,
    name: "Radio Spinner - New Age Wave",
    url: "https://live.radiospinner.com/nwagewv-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idde76ac02ef10d",
    like: false,
    name: "Radio Spinner - Night Jazz",
    url: "https://live.radiospinner.com/night-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "iddf46153df4575",
    like: false,
    name: "Radio Spinner - Nightcore Beats",
    url: "https://live.radiospinner.com/nghtcrbts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6b4bbcd4f60a8",
    like: false,
    name: "Radio Spinner - Nu Disco",
    url: "https://live.radiospinner.com/nu-disco-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id52dd17cda1c87",
    like: false,
    name: "Radio Spinner - Organic House",
    url: "https://live.radiospinner.com/rgnchs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcf09c5ed3ee45",
    like: false,
    name: "Radio Spinner - Oriental Deep House",
    url: "https://live.radiospinner.com/rntldphs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id946c4c1371a1d",
    like: false,
    name: "Radio Spinner - Paris Jazz Cafe",
    url: "https://live.radiospinner.com/prsjzzcf-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idfeae554b97e24",
    like: false,
    name: "Radio Spinner - Party 80s",
    url: "https://live.radiospinner.com/80sprty-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id121586f1af55e",
    like: false,
    name: "Radio Spinner - Piano Jazz",
    url: "https://live.radiospinner.com/piano-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idf500b6337627a",
    like: false,
    name: "Radio Spinner - Pop Cover Hit",
    url: "https://live.radiospinner.com/cvrhts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0a5431da82e55",
    like: false,
    name: "Radio Spinner - Pop Hits",
    url: "https://live.radiospinner.com/pphts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idb2d79797d206f",
    like: false,
    name: "Radio Spinner - Pop Rock Hit",
    url: "https://live.radiospinner.com/pprck-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id14096a3d4c822",
    like: false,
    name: "Radio Spinner - Progressive House",
    url: "https://live.radiospinner.com/prgrssvhs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id4b4fb1db223e3",
    like: false,
    name: "Radio Spinner - Relax & Nature",
    url: "https://live.radiospinner.com/complete-relaxation-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "id97d889913cfb8",
    like: false,
    name: "Radio Spinner - Retro Gold",
    url: "https://live.radiospinner.com/rtrgld-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idb152ecdb8b75f",
    like: false,
    name: "Radio Spinner - Retro Party",
    url: "https://live.radiospinner.com/rtrprty-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id1d43e4779324a",
    like: false,
    name: "Radio Spinner - Rock Ballads",
    url: "https://live.radiospinner.com/rckbllds-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id93a5627f6879b",
    like: false,
    name: "Radio Spinner - Rock Hits 70s",
    url: "https://live.radiospinner.com/70srckhts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "idac9e1444f1aa3",
    like: false,
    name: "Radio Spinner - Rock Hits 80s",
    url: "https://live.radiospinner.com/80srckhts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idff2561803c101",
    like: false,
    name: "Radio Spinner - Rock Hits 90s",
    url: "https://live.radiospinner.com/90srckhts-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id06e924aaa4f11",
    like: false,
    name: "Radio Spinner - Sax Jazz",
    url: "https://live.radiospinner.com/saxophone-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idb2acde96c1ceb",
    like: false,
    name: "Radio Spinner - Sleep & Relax",
    url: "https://live.radiospinner.com/sleep-relax-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "idec1c68b0b391",
    like: false,
    name: "Radio Spinner - Smooth Jazz",
    url: "https://live.radiospinner.com/smooth-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "id3cb2aac40467",
    like: false,
    name: "Radio Spinner - Smooth Lounge",
    url: "https://live.radiospinner.com/smthlng-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id72888f444c4ad",
    like: false,
    name: "Radio Spinner - Smooth Vocal Jazz",
    url: "https://live.radiospinner.com/smooth-vocal-jazz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idb33d65fa0ecef",
    like: false,
    name: "Radio Spinner - Soft Rock",
    url: "https://live.radiospinner.com/sftrck-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "idba9df6f650f97",
    like: false,
    name: "Radio Spinner - Synth Pop",
    url: "https://live.radiospinner.com/synthpp-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2b344e4529b36",
    like: false,
    name: "Radio Spinner - Synthwave",
    url: "https://live.radiospinner.com/synthwave-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "iddc8569334004",
    like: false,
    name: "Radio Spinner - Tech House",
    url: "https://live.radiospinner.com/tech-house-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id11428347ad69e",
    like: false,
    name: "Radio Spinner - Techno",
    url: "https://live.radiospinner.com/techno-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida437ced3e0848",
    like: false,
    name: "Radio Spinner - Top 40",
    url: "https://live.radiospinner.com/tp40zar-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id79c3d9996d9d3",
    like: false,
    name: "Radio Spinner - Trance",
    url: "https://live.radiospinner.com/trance-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id243ba5f39fb8b",
    like: false,
    name: "Radio Spinner - Trap",
    url: "https://live.radiospinner.com/trp-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd66753173e031",
    like: false,
    name: "Radio Spinner - Tropical House",
    url: "https://live.radiospinner.com/tropical-house-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id39b80797c910d",
    like: false,
    name: "Radio Spinner - Vocal House",
    url: "https://live.radiospinner.com/vclhs-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf71d32318422a",
    like: false,
    name: "Radio Spinner - Vocal Trance",
    url: "https://live.radiospinner.com/vcltrnc-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id3152dfffef1a6",
    like: false,
    name: "Radio Spinner - Vogue Dance",
    url: "https://live.radiospinner.com/vogd-96",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc772f0027afdc",
    like: false,
    name: "Radio Spinner - Zen & Relax",
    url: "https://live.radiospinner.com/relzen-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Relax",
  },
  {
    id: "idfcf7ce15af359",
    like: false,
    name: "Radio Spinner - Детские песенки",
    url: "https://live.radiospinner.com/dtskpsnk-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id77fdc498f1cee",
    like: false,
    name: "Radio Spinner - Детские сказки",
    url: "https://live.radiospinner.com/dtskskzki-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id4c9e243c8f0d3",
    like: false,
    name: "Radio Spinner - Звуки камина",
    url: "https://live.radiospinner.com/fplc-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id4c45364bfed3c",
    like: false,
    name: "Radio Spinner - Звуки моря",
    url: "https://live.radiospinner.com/sslp-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ide1ed59c26c979",
    like: false,
    name: "Radio Spinner - Колыбельная",
    url: "https://live.radiospinner.com/klby-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2a90690e70a0d",
    like: false,
    name: "Radio Spinner - Нямкин FM",
    url: "https://live.radiospinner.com/nymkn-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id35c11dfd7891",
    like: false,
    name: "Radio Spinner - Пение птиц",
    url: "https://live.radiospinner.com/bird-sounds-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idc42815b6f2ddc",
    like: false,
    name: "Radio Spinner - Русский рок",
    url: "https://live.radiospinner.com/rsskjrk-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id183537d3b88eb",
    like: false,
    name: "Radio Spinner - СССР Хит",
    url: "https://live.radiospinner.com/sssrht-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf52898526ba87",
    like: false,
    name: "Radio Spinner - Супер Дискач 90х",
    url: "https://live.radiospinner.com/90sprdsctk-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0eb795c75499e",
    like: false,
    name: "Radio Spinner - Чарт топ 100",
    url: "https://live.radiospinner.com/chrttp100-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcb758c61d5f87",
    like: false,
    name: "Radio Spinner - Шансон хит",
    url: "https://live.radiospinner.com/shnsnhit-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id73b7e76ceb383",
    like: false,
    name: "Radio Spinner - Шедевры классики",
    url: "https://live.radiospinner.com/bstclsscl-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id7fc2378e0001f",
    like: false,
    name: "Radio Spinner - Шедевры оперы",
    url: "https://live.radiospinner.com/bstpr-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id9ad67d2d4757d",
    like: false,
    name: "Radio Spinner - Это кавказ",
    url: "https://live.radiospinner.com/etkvkz-64",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id02b8f7164824e",
    like: false,
    name: "Radio The Voice In The Mix",
    url: "https://live-bauerdk.sharp-stream.com/DK_HQ_RP16.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id3d66a36431735",
    like: false,
    name: "Radio The Voice Throwback",
    url: "https://live-bauerdk.sharp-stream.com/DK_HQ_RP17.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6d30d0a5dd366",
    like: false,
    name: "Radio The Voice Urban",
    url: "https://live-bauerdk.sharp-stream.com/DK_HQ_RP15.aac",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id1d8dc5fd5c49e",
    like: false,
    name: "Radio Voyage",
    url: "https://s4.radio.co/s94d01769a/listen",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idabc8eaa4f4604",
    like: false,
    name: "Radio XFM (ARM)",
    url: "https://eu.stream4cast.com/proxy/xfmradio/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id12b225acda35f",
    like: false,
    name: "Radio Znad Wilii",
    url: "https://plays.zw.lt/zw128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id4ba70cd2eb3f8",
    like: false,
    name: "VIRGIN Radio (UK)",
    url: "https://radio.virginradio.co.uk/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2ee8af0dabada",
    like: false,
    name: "Радио Монте-Карло (КБР)",
    url: "https://a9.radioheart.ru:9024/RH37507",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id09f3a1761420d",
    like: false,
    name: "Радио Мост (Новосибирск)",
    url: "https://xn--80asehdb.xn----7sbmqvkcjqk.xn--p1ai/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id32ab7672bd047",
    like: false,
    name: "Радио Нестандарт",
    url: "https://listen.radionestandart.ru:8200/128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id48aa239f03ef5",
    like: false,
    name: "Радио Ностальгия",
    url: "https://c12.radioboss.fm:18016/nostalgia320",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0e9473e2de2e4",
    like: false,
    name: "Радио Ночное Такси",
    url: "https://c24.radioboss.fm:18237/autodj",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idb3ce562cedac8",
    like: false,
    name: "Радио Ноябрьск",
    url: "https://a6.radioheart.ru:8028/RH36649",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id8627dcaf5a4d2",
    like: false,
    name: "Радио Орфей - Зарубежная хоровая",
    url: "https://channels.fonotron.ru:8000/Chan_60_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd8af5590d883c",
    like: false,
    name: "Радио Орфей - Камерата",
    url: "https://channels.fonotron.ru:8000/Chan_76_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id24c8b8f4803d7",
    like: false,
    name: "Радио Орфей - Клавир",
    url: "https://channels.fonotron.ru:8000/Chan_77_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida4d30cb1693fd",
    like: false,
    name: "Радио Орфей - Классика Эстрады",
    url: "https://channels.fonotron.ru:8000/Chan_7_192.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id1b7c1a972f65",
    like: false,
    name: "Радио Орфей - Классика киномузыки",
    url: "https://channels.fonotron.ru:8000/Chan_9_192.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd4c71e7707ff5",
    like: false,
    name: "Радио Орфей - Классика крупных форм",
    url: "https://channels.fonotron.ru:8000/Chan_8_192.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2c89cfc665599",
    like: false,
    name: "Радио Орфей - Классика музыкального кроссовера",
    url: "https://channels.fonotron.ru:8000/Chan_6_192.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd966a042501bb",
    like: false,
    name: "Радио Орфей - Музыка кино",
    url: "https://channels.fonotron.ru:8000/Chan_67_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6735f125b5c8c",
    like: false,
    name: "Радио Орфей - Музыка мюзиклов",
    url: "https://channels.fonotron.ru:8000/Chan_66_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idada5cc27ed84e",
    like: false,
    name: "Радио Орфей - Музыка с участием духовых",
    url: "https://channels.fonotron.ru:8000/Chan_65_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id13c91fb2b28fa",
    like: false,
    name: "Радио Орфей - Популярная классика",
    url: "https://channels.fonotron.ru:8000/Chan_72_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id3a270308971f5",
    like: false,
    name: "Радио Орфей - Русская классика",
    url: "https://channels.fonotron.ru:8000/Chan_73_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id73d4b0b47571e",
    like: false,
    name: "Радио Орфей - Русская хоровая",
    url: "https://channels.fonotron.ru:8000/Chan_64_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id7997e060c8ee7",
    like: false,
    name: "Радио Орфей - Симфоническая музыка",
    url: "https://channels.fonotron.ru:8000/Chan_74_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id70c05cf506123",
    like: false,
    name: "Радио Орфей - Современная хоровая",
    url: "https://channels.fonotron.ru:8000/Chan_61_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id80f985135c7a6",
    like: false,
    name: "Радио Орфей - Фолк-музыка",
    url: "https://channels.fonotron.ru:8000/Chan_63_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id0d4f93faec644",
    like: false,
    name: "Радио Орфей - Хоры из опер",
    url: "https://channels.fonotron.ru:8000/Chan_62_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id92a48109f271e",
    like: false,
    name: "Радио Открытое Слово",
    url: "https://rs.radioslovo.net:4395/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id6dc40bc8e5de2",
    like: false,
    name: "Радио Открытое Слово - Авто Радио",
    url: "https://rs.radioslovo.net:4145/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id4786f971cc183",
    like: false,
    name: "Радио Открытое Слово - Ветхий Завет",
    url: "https://rs.radioslovo.net:4165/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idcade79c1393c9",
    like: false,
    name: "Радио Открытое Слово - Инструментальная музыка",
    url: "https://rs.radioslovo.net:4275/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idebc750cd3f2dc",
    like: false,
    name: "Радио Открытое Слово - Новый Завет",
    url: "https://rs.radioslovo.net:4055/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id09889cb448df7",
    like: false,
    name: "Радио Прикамье (Пермский край)",
    url: "https://skycaster.ru:7002/;",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id39b75bf505557",
    like: false,
    name: "Радио Ретро FM (КБР)",
    url: "https://a6.radioheart.ru:9025/RH37506",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id429c8c374b2e8",
    like: false,
    name: "Радио Русская Реклама (USA)",
    url: "https://securestreams6.autopo.st:2130/air",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "ida29b43a0f62c",
    like: false,
    name: "Радио Русская Реклама - Музыка без слов",
    url: "https://securestreams6.autopo.st:2130/instrumental",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id3de3b9bbc80c",
    like: false,
    name: "Радио Русская Реклама - Русский Хит",
    url: "https://securestreams6.autopo.st:2130/onlyrussian",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idd343f898769a6",
    like: false,
    name: "Радио Русские Эмираты",
    url: "https://a4.radioheart.ru:9041/RH32763",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "idf1a364a6e0b5b",
    like: false,
    name: "Радио Юнитон (Новосибирск)",
    url: "https://online.uniton.ru/uniton",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id66536b6555946",
    like: false,
    name: "Радиогора (Алдан)",
    url: "https://skycaster.ru/8114/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id1cd6d474d5a8e",
    like: false,
    name: "Русское Радио",
    url: "https://a9.radioheart.ru:9022/RH37504",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2a6935118f8fd",
    like: false,
    name: "Умное радио (Саров)",
    url: "https://radio.sarov.info/radio/8010/clever-radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id2f35b3092daf2",
    like: false,
    name: "Яхт-Радио Blues & Jazz",
    url: "https://yacht-radio.lv:8175/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Jazz",
  },
  {
    id: "idc5204ea0b55b5",
    like: false,
    name: "Яхт-Радио Rock",
    url: "https://yacht-radio.lv:8185/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Rock",
  },
  {
    id: "id17a15ffb69aed",
    like: false,
    name: "Яхт-Радио Классика",
    url: "https://yacht-radio.lv:8165/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
  {
    id: "id912dae8759ad3",
    like: false,
    name: "Яхт-Радио Театр",
    url: "https://yacht-radio.lv:8205/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
    genre: "Pop",
  },
]
